module.exports = __webpack_public_path__ + "img/global-warranty_logo.320219af.png";